import React, { useState } from "react";
import "./styles.css";
import { Images } from "../../theme";
import { useTranslation } from "react-i18next";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";

export default function LocationSearch(props) {
  const [locationvalue, setLocationvalue] = useState(props.value);
  const { t } = useTranslation();

  const handleChange = (address) => {
    setLocationvalue(address);
  };

  function checkValidation() {
    if (!locationvalue) {
      alert(t("Please_Select_Location"));
    } else {
      props.onClose(false);
    }
  }

  const handleSelect = async (value) => {
    setLocationvalue(value);

    let res = await geocodeByAddress(value);
    let result = await getLatLng(res[0]);
    props.locationLatLng(result, value);
  };

  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          <div>
            <p class="text-center category-txt poppins mt-4">
              {t("Please_Select_Location")}
            </p>
            <div class="input-group location-input mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text search-span">
                  <img src={Images.search} />
                </span>
              </div>
              <PlacesAutocomplete
                value={locationvalue}
                onChange={handleChange}
                onSelect={(e) => (handleSelect(e), props.locationData(e))}
              >
                {({ getInputProps, suggestions, getSuggestionItemProps }) => (
                  <div>
                    <input
                      {...getInputProps({
                        placeholder: t("Search_Places"),
                        class: "form-control location-width",
                      })}
                    />
                    <div className="autocomplete-dropdown-container">
                      <ul className="location-list p-0 mt-3">
                        {suggestions.map((suggestion) => {
                          return (
                            <li {...getSuggestionItemProps(suggestion)}>
                              {suggestion.description}
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                )}
              </PlacesAutocomplete>
              <div class="input-group-append">
                <span class="input-group-text aim-span">
                  <img src={Images.aim} />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{ position: "absolute", bottom: 15, right: 15 }}
        onClick={checkValidation}
      >
        <button class="btn-custom btn-light">{t("Confirm")}</button>
      </div>
    </>
  );
}
